/* eslint-disable no-multi-str */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';
import ImageUploader from './common/UploadImage';
import { Editor } from '@tinymce/tinymce-react';
import Axios from 'axios';
import Input from './common/Input';
import { Badge, Form } from 'react-bootstrap';
import { XSquare } from 'react-bootstrap-icons';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';

const SingleBlog = (props) => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const [selectedImages, setSelectedImages] = useState([]);
    const [uploadButtonDisabled, setUploadButtonDisabled] = useState(true);
    const [title, setTitle] = useState('');
    const [status, setStatus] = useState('active');
    const [statusOptions, setStatusOptions] = useState([{ value: 'active', name: 'Active' }, { value: 'inactive', name: 'Inactive' }]);
    const [message, setMessage] = useState('');
    const [content, setContent] = useState('');
    const [images, setImages] = useState([]);
    const [edate, setEdate] = useState('');
    const [cat, setCat] = useState('');
    const [showInPopUP, setShowInPopUP] = useState('no');

    const history = useHistory();

    const fetchClient = () => {
        coreContext.fetchBlog(props.location, authContext.itemId);
    }

    const { register, handleSubmit, errors } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onBlur',
    });

    useEffect(fetchClient, []);

    const populateClient = () => {
        setTitle(coreContext.blog.title);
        setMessage(coreContext.blog.message);
        setContent(coreContext.blog.pageContent);
        setEdate(coreContext.blog.bdate);
        setCat(coreContext.blog.bcategory);
        setShowInPopUP(coreContext.blog.show_in_popup);
        setImages(coreContext.blog.blog_images);
    }

    useEffect(populateClient, [coreContext.blog]);

    const deleteImage = (id) => {

        deleteBlogImage(id);
    }

    const deleteBlogImage = (id) => {

        Axios.post('/delete-blog-image', { id }).then((response) => {
            const newImages = images.filter(image => image.id !== id);
            setImages(newImages);
        }).catch(err => { });
    }




    const renderImages = () => {
        if (images)
            return images.map(image => <div style={{ position: 'relative' }} key={image.id} className="col-md-6"><img style={{ padding: 5 }} className="img-fluid" src={`http://${image.url}`} alt='gallery image' /> <button onClick={() => deleteImage(image.id)} style={{ position: 'absolute', top: 0, left: 5 }} type="button" className="btn btn-danger btn-sm" title="Delete Image"> <XSquare size="12" /> </button></div>)
    }

    const onImagesUploadHandler = async () => {
        const count = selectedImages.length;
        let counter = 0;

        for await (const image of selectedImages) {
            ++counter;
            const formData = new FormData();
            formData.append('itemId', authContext.itemId);
            formData.append('blogId', coreContext.blog.id);
            formData.append('image', image, image.name);
            formData.append('userId', authContext.userId);
            coreContext.uploadBlogImage(formData, authContext.itemId, coreContext.blog.id);

            if (counter === count) {
                setTimeout(() => {
                    setSelectedImages([]);
                    coreContext.fetchBlogImages(authContext.itemId, coreContext.blog.id);
                }, 2000);

                setTimeout(() => {
                    history.push('/blogs');
                }, 5000);
            };
        }
    }

    const onTitleChangedHandler = (e) => {
        setTitle(e.target.value);
    }
    const onMessageChangedHandler = (e) => {
        setMessage(e.target.value);
    }

    const handleEditorChange = (content, editor) => {
        setContent(content);
    }
    const onEDateChangedHandler = (e) => {
        setEdate(e.target.value);
    }
    const onCatChangedHandler = (e) => {
        setCat(e.target.value);
    }

    const onStatusChangedHandler = (e) => {
        setStatus(e.target.value);
    }

    const showInPopUpChangeHandler = (e) => {
        if (showInPopUP === 'yes')
            setShowInPopUP('no');
        else
            setShowInPopUP('yes');
    }

    const onBlogContentHandler = (data) => {
        coreContext.updateBlogContent(title, message, content, edate, cat, showInPopUP, status, authContext.itemId, coreContext.blog.id);

    }

    const onImagesSelected = (pictures) => {
        setSelectedImages(pictures);
        //  console.log(pictures);
        if (pictures.length > 0) setUploadButtonDisabled(false); else setUploadButtonDisabled(true);
    }

    return (<div className='container-fluid'>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Edit Blog</Badge></h3></div>
            <div className="card-body">
                <Form autoComplete='off' onSubmit={handleSubmit(onBlogContentHandler)} noValidate>
                    <Input label='Title' value={title} name='title' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Title' onChange={onTitleChangedHandler} />

                    <Input label='Image Message' value={message} name='message' minLength={2} maxLength={2000} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Message' onChange={onMessageChangedHandler} />

                    <div className="row"><div className="col-md-3">
                        <Input label='Blog Date' value={edate} name='edate' minLength={2} maxLength={50} required={true} register={register} errors={errors} elementType='date' placeholder='Enter Blog Date' onChange={onEDateChangedHandler} />
                    </div>
                        <div className="col-md-3">
                            <Input label='Blog Category' value={cat} name='cat' minLength={2} maxLength={50} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Blog Category : eg. Education or Fashion or CBSE' onChange={onCatChangedHandler} />
                        </div>
                        <div className="col-md-3">
                            <Input label='Status' name='status' required={true} register={register} errors={errors} elementType='select' value={status} options={statusOptions} onChange={onStatusChangedHandler} />
                        </div>
                        <div className="col-md-3"> <Input elementType='checkbox' checked={showInPopUP === 'yes'} value="Show In Pop-UP" onChange={showInPopUpChangeHandler} /></div>

                    </div>

                    <Editor
                        apiKey={'5k5x5ez6z06mvgu1fkuizuc0wa07bqni14qml1baljvj2ijp'}
                        value={content}
                        init={{
                            height: 500,
                            menubar: 'insert',
                            file_picker_types: 'file image media',
                            plugins: [
                                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                            ],
                            toolbar:
                                'undo redo | formatselect | bold italic backcolor forecolor  | fontsize fontfamily lineheight | \
         alignleft aligncenter alignright alignjustify | \
         bullist numlist outdent indent image | removeformat | code | help'
                        }}
                        onEditorChange={handleEditorChange}
                    />

                    <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()}
                    <Input variant='danger' label={coreContext.message} elementType='label' />

                </Form>
            </div>
        </div>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Upload Blog Images</Badge></h3></div>
            <div className="card-title mx-auto">Best Image Size 500*333</div>
            <div className="card-body">
                <ImageUploader onImagesSelected={onImagesSelected} maxWidthOrHeight='500' pictures={selectedImages} />
                <Input value='Upload Images' onClick={onImagesUploadHandler} disabled={uploadButtonDisabled} elementType='button' variant='primary' />&nbsp;&nbsp; {coreContext.renderLoader()}
                <Input variant='danger' label={coreContext.message} elementType='label' />
            </div>
            <div className="card-body">
                <div className="card-title mx-auto"><h3><Badge variant="success">Blog Images</Badge></h3></div>
                <div className="row">
                    {renderImages()}
                </div>
            </div>
        </div>
    </div>
    )
}

export { SingleBlog }